<lib-sales-insights-card
  [cardTitle]="config?.title"
  [accent]="accent"
  [accentRgb]="colorRgb"
  [loading]="loading"
  [error]="error"
  [empty]="empty"
>
  @if (delta) {
    <span
      cardActions
      class="si-kpi__delta"
      [class.si-kpi__delta--up]="delta.direction === 'up'"
      [class.si-kpi__delta--down]="delta.direction === 'down'"
      [title]="comparisonTitle"
    >
      @if (delta.direction === 'up') {
        <i class="fa-solid fa-arrow-trend-up"></i>
      } @else if (delta.direction === 'down') {
        <i class="fa-solid fa-arrow-trend-down"></i>
      }
      {{ delta.text }}
    </span>
  }
  <div class="si-kpi">
    <div class="si-kpi__value" [class.si-kpi__value--danger]="accent === 'danger'" [title]="periodRange">
      {{ value }}
      @if (unit) {
        <span class="si-kpi__unit">{{ unit }}</span>
      }
    </div>
    @if (subline) {
      <div class="si-kpi__subline" [title]="comparisonTitle">{{ subline }}</div>
    }
    @if (targetValue) {
      <div class="si-kpi__target">
        @if (targetPercent !== null) {
          <div class="si-kpi__target-bar" aria-hidden="true">
            <span [style.width.%]="targetPercent > 100 ? 100 : targetPercent" [style.background]="'rgb(' + colorRgb + ')'"></span>
          </div>
        }
        <div class="si-kpi__target-text">
          @if (targetAttainment) {
            <b>{{ targetAttainment }}</b>
          }
          <span>{{ targetValue }}</span>
        </div>
      </div>
    }
    @if (sparklineData.length) {
      <div class="si-kpi__sparkline-slot" aria-hidden="true">
        <div class="si-kpi__sparkline">
          <canvas
            baseChart
            type="line"
            [labels]="sparklineLabels"
            [datasets]="sparklineData"
            [options]="sparklineOptions"
          ></canvas>
        </div>
      </div>
    }
  </div>
</lib-sales-insights-card>
